import { Component, createRef } from "react";
import withAuth from "../withAuth";
import { withStyles } from "@mui/styles";
import { compose } from "redux";
import { connect } from "react-redux";
import TableWithoutPagination from "../Table/TableWithoutPagination";
import MenuItem from "@mui/material/MenuItem";
import Icon from "@mui/material/Icon/Icon";
import Button from "@mui/material/Button/Button";
import CommentModal from "./CommentModal";
import SmallLabelAndCheckBox from "./SmallLabelAndCheckBox";
import {
    setSolutions,
    getDefaultSolution,
    fillIdOfSolutionAndAddCreationSolution,
    toShortName,
    setNbCompaniesDisplay,
} from "../../redux/analyseRisques/analyseRisquesActions";
import { throwErrorMessage } from "../../lib/error_helper";
import "./SolutionsTable.css";
import { FormControl, InputLabel } from "@mui/material";
import CustomizedSelect from "../Input/CustomizedSelect";

const styles = (theme) => ({
    root: {
        width: "100%",
        marginTop: theme.spacing(3),
        overflowX: "auto",
    },
    table: {
        minWidth: 700,
    },
    row: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.background.default,
        },
    },
});

class SolutionsTable extends Component {
    constructor(props) {
        super(props);

        this.table = createRef();

        this.state = {
            comment: false,
            columns: [
                {
                    Header: "Mesures",
                    columns: [
                        {
                            Header: "",
                            id: "actions",
                            width: 20,
                            Cell: this.renderButtons.bind(this),
                        },
                        {
                            Header: "Type",
                            width: 200,
                            Cell: ({ row }) => {
                                let solutions = this.props.solutions.filter((s) => !s.deleted);

                                if (!solutions[row.index] || solutions[row.index].id === 0) return null;

                                let selectedRiskTypeId = this.props.currentRisk.riskTypeId;

                                let selectedRiskTypes = this.props.riskTypes.filter(
                                    (rt) => rt.id === selectedRiskTypeId
                                );

                                let instructionTypes = [];

                                if (selectedRiskTypes.length > 0)
                                    instructionTypes = this.props.instructionTypes.filter(
                                        (i) =>
                                            i.measure_type === "measure" &&
                                            selectedRiskTypes[0].measure_ids.map((m) => m.id).includes(i.id)
                                    );

                                return (
                                    <div className="center col-lg-12 col-md-12 col-sm-12 col-12 row without-padding solution-table-row-padding">
                                        <FormControl className="row">
                                            <InputLabel id="solution-label">Type de mesure</InputLabel>
                                            <CustomizedSelect
                                                labelId="solution-label"
                                                id="solution"
                                                label="Type de mesure"
                                                placeholder="Type de mesure"
                                                className="full_size"
                                                required
                                                onChange={this.solutionTypeChange.bind(this, row.index)}
                                                value={
                                                    solutions[row.index].solutionTypeId
                                                        ? solutions[row.index].solutionTypeId
                                                        : ""
                                                }
                                            >
                                                {instructionTypes.map((at) => {
                                                    return (
                                                        <MenuItem key={at.id} value={at.id}>
                                                            {at.name}
                                                        </MenuItem>
                                                    );
                                                })}
                                            </CustomizedSelect>
                                        </FormControl>
                                    </div>
                                );
                            },
                        },
                        {
                            Header: "Intervenants",
                            width: 300,
                            Cell: ({ row }) => {
                                let solutions = this.props.solutions.filter((s) => !s.deleted);

                                if (!solutions[row.index] || solutions[row.index].id === 0) return null;

                                return (
                                    <div className="center col-lg-12 col-md-12 col-sm-12 col-12 row without-padding">
                                        {this.props.analyseRisques.raCompanies
                                            .filter(
                                                (c, idx) =>
                                                    this.props.nbCompaniesDisplay[this.props.currentRisk.id] &&
                                                    idx <
                                                        this.props.nbCompaniesDisplay[this.props.currentRisk.id][
                                                            solutions[row.index].id
                                                        ]
                                            )
                                            .map((c) => {
                                                return (
                                                    <div className="col-4 without-side-padding" key={c.id}>
                                                        <SmallLabelAndCheckBox
                                                            onChange={this.checkConcernedCompany.bind(
                                                                this,
                                                                c,
                                                                row.index
                                                            )}
                                                            label={toShortName(c)}
                                                            checked={
                                                                solutions[row.index].concernedCompanies.find(
                                                                    (cc) => cc.company.id === c.id
                                                                ).concerned
                                                            }
                                                        />
                                                    </div>
                                                );
                                            })}
                                        {this.props.nbCompaniesDisplay[this.props.currentRisk.id] &&
                                        this.props.nbCompaniesDisplay[this.props.currentRisk.id][
                                            solutions[row.index].id
                                        ] < this.props.analyseRisques.raCompanies.length ? (
                                            <div className="col-4 without-side-padding">
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-padding">
                                                    <span className="label-small-label-check-box"></span>
                                                </div>
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-padding">
                                                    <Button
                                                        onClick={this.increaseNbCompaniesDisplay.bind(
                                                            this,
                                                            solutions[row.index].id
                                                        )}
                                                        className="col-lg-12 col-md-12 col-sm-12 col-12 small-btn without-padding without-side-margin"
                                                        color="primary"
                                                    >
                                                        <Icon className="small-icon">add</Icon>
                                                    </Button>
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>
                                );
                            },
                        },
                        {
                            Header: "",
                            id: "comment",
                            width: 20,
                            Cell: this.renderComment.bind(this),
                        },
                    ],
                },
            ],
        };
    }

    increaseNbCompaniesDisplay(solutionId) {
        let nbCompaniesDisplay = { ...this.props.nbCompaniesDisplay };
        nbCompaniesDisplay[this.props.currentRisk.id][solutionId] =
            nbCompaniesDisplay[this.props.currentRisk.id][solutionId] + 1;
        this.props.setNbCompaniesDisplay(nbCompaniesDisplay);
    }

    checkConcernedCompany(company, index) {
        let solutions = [...this.props.solutions];

        if (!solutions[index]) return;

        let concernedCompany = solutions[index].concernedCompanies.find((c) => c.company.id === company.id);

        if (concernedCompany) concernedCompany.concerned = !concernedCompany.concerned;

        this.props.setSolutions(
            solutions,
            this.props.currentRisk.id,
            this.props.currentRisks,
            this.props.raCompanies,
            this.props.sppCompanies,
            this.props.participants,
            this.props.moduleSpp
        );
    }

    solutionTypeChange(rowIndex, e) {
        let solutions = [...this.props.solutions];

        if (!solutions[rowIndex]) return;

        solutions[rowIndex].solutionTypeId = e.target.value;
        solutions[rowIndex].commentRequired = this.props.instructionTypes.find(
            (st) => st.id === e.target.value
        ).commentRequired;

        this.props.setSolutions(solutions, this.props.currentRisk.id, this.props.currentRisks);
    }

    addSolution(element) {
        let solutions = [...this.props.solutions];

        if (!solutions[element.row.index]) return;

        if (solutions[element.row.index - 1] && !solutions[element.row.index - 1].solutionTypeId) {
            this.props.throwErrorMessage({
                title: "Information",
                message: "Type de solution non renseignée pour la ligne précédente",
            });

            return;
        }

        solutions = fillIdOfSolutionAndAddCreationSolution(
            solutions,
            this.props.instructionTypes,
            this.props.activeUser
        );

        this.props.setSolutions(
            solutions,
            this.props.currentRisk.id,
            this.props.currentRisks,
            this.props.raCompanies,
            this.props.sppCompanies,
            this.props.participants,
            this.props.moduleSpp
        );
    }

    removeSolution(elementToDelete) {
        const solutions = this.props.solutions;

        let indexOfSolutionToDelete = elementToDelete.row.index;

        if (indexOfSolutionToDelete !== undefined && indexOfSolutionToDelete >= 0) {
            solutions[indexOfSolutionToDelete].deleted = true;

            let indexOfCreationLine = solutions.find(function (element) {
                return element.id === 0;
            });

            if (!indexOfCreationLine) {
                solutions.push(getDefaultSolution(this.props.activeUser.email, this.props.participants));
            }

            this.props.setSolutions(
                solutions,
                this.props.currentRisk.id,
                this.props.currentRisks,
                this.props.raCompanies,
                this.props.sppCompanies,
                this.props.participants,
                this.props.moduleSpp
            );
        }
    }

    editComment() {
        this.setState({
            comment: true,
        });
    }

    close() {
        this.setState({
            comment: false,
        });
    }

    renderComment(row) {
        if (
            row.row.original.id === 0 ||
            this.props.instructionTypes.filter((st) => st.id === row.row.original.solutionTypeId && st.commentRequired)
                .length === 0
        )
            return <div></div>;

        return (
            <div>
                <div className="solution-table-row-padding">
                    <Button
                        onClick={this.editComment.bind(this)}
                        className="col-lg-12 col-md-12 col-sm-12 col-12 small-btn without-padding without-side-margin"
                        color="primary"
                    >
                        <Icon className={row.row.original.comment ? "green-icon small-icon" : "red-icon small-icon"}>
                            chat_bubble
                        </Icon>
                    </Button>
                    <CommentModal
                        onRef={(ref) => (this.commentModal = ref)}
                        close={this.close.bind(this)}
                        open={this.state.comment}
                        currentSolution={row.row.original}
                        solutions={this.props.solutions}
                        currentRisk={this.props.currentRisk}
                        currentRisks={this.props.currentRisks}
                    />
                </div>
            </div>
        );
    }

    renderButtons(row) {
        if (row.row.original.id === 0)
            return (
                <div>
                    <Button
                        onClick={this.addSolution.bind(this, row)}
                        className="col-lg-12 col-md-12 col-sm-12 col-12 small-btn without-padding without-side-margin"
                        color="primary"
                    >
                        <Icon className="small-icon">add</Icon>
                    </Button>
                </div>
            );

        return (
            <div className="solution-table-row-padding">
                <Button
                    onClick={this.removeSolution.bind(this, row)}
                    className="col-lg-12 col-md-12 col-sm-12 col-12 small-btn without-padding without-side-margin"
                    color="primary"
                >
                    <Icon className="small-icon">delete</Icon>
                </Button>
            </div>
        );
    }

    render() {
        return (
            <TableWithoutPagination
                key={this.props.currentRisk.id}
                ref={this.table}
                data={this.props.solutions.filter((s) => !s.deleted)}
                columns={this.state.columns}
                minRows={5}
                contentEditable
                getTrProps={(state, rowInfo) => {
                    if (rowInfo && rowInfo.original.id === 0 && !rowInfo.original.deleted) {
                        return {
                            style: {
                                background: "#E3F2FD",
                            },
                        };
                    } else {
                        return {};
                    }
                }}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        instructionTypes: state.solutionTypes.types,
        riskTypes: state.riskTypes.types,
        currentRisks: state.analyseRisques.risks,
        raCompanies: state.analyseRisques.raCompanies,
        sppCompanies: state.analyseRisques.sppCompanies,
        analyseRisques: state.analyseRisques,
        moduleSpp: state.analysesRisques.moduleSpp,
        participants: state.analyseRisques.participants,
        nbCompaniesDisplay: state.analyseRisques.nbCompaniesDisplay,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSolutions: (
            currentSolutions,
            currentRiskId,
            currentRisks,
            raCompanies,
            sppCompanies,
            participants,
            moduleSpp
        ) =>
            dispatch(
                setSolutions(
                    currentSolutions,
                    currentRiskId,
                    currentRisks,
                    raCompanies,
                    sppCompanies,
                    participants,
                    moduleSpp
                )
            ),
        throwErrorMessage: (options) => dispatch(throwErrorMessage(options)),
        setNbCompaniesDisplay: (nbCompaniesDisplay) => dispatch(setNbCompaniesDisplay(nbCompaniesDisplay)),
    };
};

export default compose(withAuth, withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(SolutionsTable);
